






import { defineComponent, PropType } from '@vue/composition-api'

export const messages = ['none', 'success', 'warning', 'danger'] as const
export type MessageType = typeof messages[number]

export default defineComponent({
  props: {
    type: {
      type: String as PropType<MessageType>,
      default: 'none'
    }
  }
})
